import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login/login";
import Main from "./layout/main/main";
import Toast from "./components/toast/toast";

function App() {
  return (
    <Router>
      <Toast />

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<Main />} />
      </Routes>
    </Router>
  );
}

export default App;
